(function(){

    /* globals $ */

    'use strict';

    var ContactDataInput = function(widget, type) {

        this.widget = widget;

        var icon, inputGroupAddon, valueField,
            kindField, isWorkField, deleteButton,
            inputGroup, formGroup, index;

        index = document.querySelectorAll('input[name$="[value]"]').length;

        icon = document.createElement('i');
        icon.classList.add('fa');
        icon.classList.add(this.typeToIcon(type));

        inputGroupAddon = document.createElement('span');
        inputGroupAddon.classList.add('input-group-addon');
        inputGroupAddon.appendChild(icon);

        valueField = document.createElement('input');
        valueField.classList.add('form-control');
        valueField.setAttribute('type', this.typeToHtmlType(type));
        valueField.setAttribute('name', 'contact[contact_data_attributes][' + index +'][value]');

        this.input = valueField;

        kindField = document.createElement('input');
        kindField.setAttribute('type', 'hidden');
        kindField.setAttribute('name', 'contact[contact_data_attributes][' + index +'][kind]');
        kindField.setAttribute('value', type);

        isWorkField = document.createElement('input');
        isWorkField.setAttribute('type', 'hidden');
        isWorkField.setAttribute('name', 'contact[contact_data_attributes][' + index +'][is_work]');
        isWorkField.setAttribute('value', this.widget.isWork);

        icon = document.createElement('i');
        icon.classList.add('fa');
        icon.classList.add('fa-trash');

        deleteButton = document.createElement('span');
        deleteButton.classList.add('input-group-addon');
        deleteButton.classList.add('btn');
        deleteButton.appendChild(icon);
        deleteButton.addEventListener('click', this.handleDelete, false);

        inputGroup = document.createElement('div');
        inputGroup.classList.add('input-group');
        inputGroup.appendChild(inputGroupAddon);
        inputGroup.appendChild(valueField);
        inputGroup.appendChild(kindField);
        inputGroup.appendChild(isWorkField);
        inputGroup.appendChild(deleteButton);

        formGroup = document.createElement('div');
        formGroup.classList.add('form-group');
        formGroup.appendChild(inputGroup);

        this.element = formGroup;

    };

    ContactDataInput.prototype.typeToIcon = function(type) {

        if(type === 'e_mail') {
            type = 'fa-envelope';
        } else if(type === 'website') {
            type = 'fa-globe';
        } else {
            type = 'fa-' + type;
        }

        return type;

    };

    ContactDataInput.prototype.typeToHtmlType = function(type) {

        if(type === 'e_mail') {
            type = 'email';
        } else if(type === 'website') {
            type = 'url';
        } else {
            type = 'text';
        }

        return type;

    };

    ContactDataInput.prototype.appendTo = function(parent) {
        parent.appendChild(this.element);
    };

    ContactDataInput.prototype.setFocus = function() {
        this.input.focus();
    };

    ContactDataInput.prototype.handleDelete = function() {

        var element = this.parentElement.parentElement;
        element.parentElement.removeChild(element);

    };

    var ContactDataWidget = function(wrapper, isWork) {

        var i, icons;

        this.wrapper = wrapper;
        this.isWork = isWork;
        this.container = this.wrapper.querySelector('.box-body');
        this.buttons = this.wrapper.querySelectorAll('[data-contact-type]');

        for (i = 0; i < this.buttons.length; ++i) {

            this.buttons[i].widget = this;
            this.buttons[i].addEventListener('click', this.clickHandler, false);

        }

        icons = this.container.querySelectorAll('.input-group-addon.btn');

        for (i = 0; i < icons.length; ++i) {

            icons[i].addEventListener('click', function() {

                var parent, element, value;

                parent = this.parentElement;

                element = parent.querySelector('input[name$="[id]"]');

                if(!element.getAttribute('value')) {

                    parent.parentElement.remove();
                    return;

                }

                element = parent.querySelector('input[name$="[value]"]');

                element.disabled = !element.disabled;

                element = parent.querySelector('input[name$="[_destroy]"]');

                value = element.getAttribute('value');

                if(value === 'true') {
                    element.setAttribute('value', 'false');
                } else {
                    element.setAttribute('value', 'true');
                }

            }, false);

        }

    };

    ContactDataWidget.prototype.clickHandler = function(e) {

        var input;

        e.preventDefault();

        input = new ContactDataInput(this.widget, this.dataset.contactType);

        input.appendTo(this.widget.container);
        input.setFocus();

    };

    ContactDataWidget.initialize = function() {

        var contactData = document.querySelector('#contact-data');

        if(contactData) {
            contactData = new ContactDataWidget(contactData, false);
        }

        var professionalContactData = document.querySelector('#professional-contact-data');

        if(professionalContactData) {
            professionalContactData = new ContactDataWidget(professionalContactData, true);
        }

    };

    ContactDataWidget.initialize();

    $('body').on('modal:show', function() {
        ContactDataWidget.initialize();
    });

})();